<template>
    <div>
        <load-spinner :loading="isLoading" />
        <b-card>
            <div>
                <b-form-group
                    label="Assessments / Evidence"
                >
                    <b-form-checkbox-group
                        v-model="final_record.assessments_evidence"
                        :options="options"
                        :disabled="true"
                        :state="completed ? null : getState('assessments_evidence')"
                    />
                    <b-form-invalid-feedback
                        :state="completed ? null : getState('assessments_evidence')"
                    >
                        Please select at least two pieces of evidence
                    </b-form-invalid-feedback>
                </b-form-group>
                <div class="row mt-2 mb-2">
                    <collapse-card
                        title="Student Evidence"
                        :open="true"
                    >
                        <enrolment-attachments
                            :enrolment="enrolment"
                            :archived="true"
                            size="lg"
                        />
                    </collapse-card>
                </div>
                <div class="row">
                    <collapse-card
                        title="Determination of competence"
                        :open="true"
                        collapseid="assessText"
                    >
                        All assessment tasks must be completed satisfactorily to be able to determine competent.
                    </collapse-card>
                </div>
                <b-form-group
                    label="Competency outcome"
                >
                    <b-form-radio-group
                        v-model="final_record.competency_outcome"
                        :options="competencyOutcomes"
                        :disabled="true"
                        :state="completed ? null : getState('competency_outcome')"
                        size="lg"
                    />
                    <b-form-invalid-feedback
                        :state="completed ? null : getState('competency_outcome')"
                    >
                        Student must be competent
                    </b-form-invalid-feedback>
                </b-form-group>
                <hr>
                <b-form-group
                    label="Feedback to student"
                >
                    <b-textarea
                        v-model="final_record.feedback_to_student"
                        :disabled="true"
                        rows="3"
                        placeholder="Feedback to student"
                        :state="completed ? null : getState('feedback_to_student')"
                    />
                    <b-form-invalid-feedback
                        :state="completed ? null : getState('feedback_to_student')"
                    >
                        Must be greater than 40 characters
                    </b-form-invalid-feedback>
                </b-form-group>
            </div>
            <div class="form-group">
                <label>Date for Reassessment</label>
                <datepicker
                    id="date_for_reassessment"
                    v-model="date_for_reassessment"
                    :disabled="true"
                    format="dd/MM/yyyy"
                    bootstrap-styling
                />
            </div>
            <div>
                <b-row>
                    <b-col>
                        <label>Student</label>
                        <!-- eslint-disable vue/no-v-html -->
                        <span
                            v-if="assessmentTool && assessmentTool.final_record_student_sign"
                            v-html="assessmentTool ? assessmentTool.final_record_student_sign : ''"
                        />
                        <!-- eslint-enable vue/no-v-html -->
                        <signature-pad-component
                            v-else-if="assessmentTool.final_record_unlocked_at"
                            v-model="final_record_student_sign"
                            signature-type="final_record_student_sign"
                        />
                        <b-btn
                            variant="secondary"
                            v-else
                            :disabled="true"
                        >
                            <i class="fas fa-lock"></i> LOCKED
                        </b-btn>
                    </b-col>
                    <b-col>
                        <label>Assessor</label>
                        <!-- eslint-disable vue/no-v-html -->
                        <span
                            v-if="assessmentTool && assessmentTool.final_record_assessor_sign"
                            v-html="assessmentTool ? assessmentTool.final_record_assessor_sign : ''"
                        />
                    </b-col>
                </b-row>
            </div>
            <div>
                <b-form-group
                    label="Reporting requirements"
                >
                    <b-textarea
                        v-model="final_record.reporting_requirements"
                        :disabled="true"
                        rows="3"
                        placeholder="Reporting requirements"
                    />
                </b-form-group>
            </div>
            <hr>
            <div
                v-if="!completed"
                class="row"
            >
                <b-col>
                    <b-button
                        variant="primary"
                        @click="saveFinalRecord"
                    >
                        Save
                    </b-button>
                </b-col>
            </div>
            <div
                v-else
                class="row"
            >
                <b-alert
                    variant="success"
                    show
                >
                    Section Completed by {{ assessmentTool.final_record_name }}
                    @ {{ assessmentTool.final_record_date | dateFormat }}
                </b-alert>
            </div>
        </b-card>
    </div>
</template>

<script>

import CollapseCard from './CollapseCardComponent.vue';
import SignaturePadComponent from '../SignaturePadComponent.vue';
import EnrolmentAttachments from '../Student/EnrolmentAttachments.vue';

/* global moment */
/* global axios */
/* global Noty */

export default {
    components: {
        'collapse-card': CollapseCard,
        SignaturePadComponent,
        EnrolmentAttachments
    },
    filters: {
        dateFormat(val) {
            if (val) {
                return moment(val).format('DD/MM/YYYY HH:mm:ss');
            }
            return '';
        },
    },
    props: {
        assessmentToolMain: {
            type: Object,
            required: true,
        },
        enrolment: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            assessmentTool: {},
            yesNo: [
                { text: 'Yes', value: 'Yes' },
                { text: 'No', value: 'No' },
            ],
            final_record: {},
            selected: [],
            options: ['Knowledge Assessment', 'Demonstration Assessment', 'Third Party Report', 'Case Study Assessment', 'Portfolio of Evidence'],
            final_record_assessor_sign: '',
            final_record_student_sign: '',
            competencyOutcomes: [
                { text: 'Competent', value: 'Competent' },
                { text: 'Not yet competent', value: 'Not yet Competent' },
            ],
            date_for_reassessment: null,
        };
    },
    computed: {
        completed() {
            return ((this.assessmentTool.final_record_status === 2 || this.assessmentTool.final_record_status === '2')
                || this.enrolment.result === 'COM' || this.enrolment.result == 'GCA');
        },
    },
    watch: {
        assessmentTool() {
            if (this.assessmentTool.final_record) {
                this.final_record = JSON.parse(this.assessmentTool.final_record);
                if (this.final_record.date_for_reassessment !== 'dd/mm/yyyy'
                        && this.final_record.date_for_reassessment !== ''
                        && this.final_record.date_for_reassessment !== null
                        && this.final_record.date_for_reassessment !== undefined
                ) {
                    this.date_for_reassessment = moment(this.final_record.date_for_reassessment, 'DD/MM/YYYY').toDate();
                }
            }
        },
    },
    mounted() {
        this.fetchAssessmentToolData();
    },
    methods: {
        getState(prop) {
            if (prop === 'assessments_evidence') {
                if (this.final_record[prop]) {
                    return this.final_record[prop].length >= 2;
                }
                return null;
            }
            if (prop === 'feedback_to_student') {
                if (this.final_record[prop]) {
                    return this.final_record[prop].length >= 40;
                }
                return null;
            }
            if (prop === 'competency_outcome') {
                if (this.final_record[prop]) {
                    return this.final_record[prop] === 'Competent';
                }
                return null;
            }
            return null;
        },
        saveFinalRecord() {
            this.isLoading = true;
            axios
                .put(`/api/assessment-tool-final-record/${this.assessmentTool.id}`, {
                    student_sig: this.final_record_student_sign,
                })
                .then((res) => {
                    this.assessmentTool = res.data.data;
                    new Noty({
                        text: `Saved! ${res.data && res.data.message ? res.data.message : ''}`,
                        type: 'success',
                    }).show();
                })
                .catch((e) => {
                    new Noty({
                        text: `Error saving! ${e.response && e.response.data && e.response.data.message ? e.response.data.message : ''}`,
                        type: 'error',
                    }).show();
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        fetchAssessmentToolData() {
            this.isLoading = true;
            axios
                .get('/api/assessment-tool', {
                    params: {
                        enrolment_id: this.enrolment.id,
                    },
                })
                .then((response) => {
                    this.assessmentTool = response.data.data;
                })
                .catch(() => {
                    const n = new Noty({
                        text: 'Error fetching assessment tool data',
                        type: 'error',
                    });
                    n.show();
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
    },
};

</script>

<style>
    .datepickerWhite {
        background-color: white !important;
    }
</style>
